import { useLayoutEffect, useRef } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Obj, type ObjId } from './Obj.tsx'

/** `also`: child sections that keep this tab lit (docs/UX-PLAYBOOK.md §3: /ayat/*, /pegangan/* and settings belong to Beranda). */
type Tab = { to: string; label: string; obj: ObjId; also?: string[] }

const TABS: Tab[] = [
  { to: '/', label: 'Beranda', obj: 'tab-beranda', also: ['/ayat', '/pegangan', '/pengaturan', '/bantuan'] },
  { to: '/mutiara', label: 'Mutiara', obj: 'tab-mutiara' },
  { to: '/perjalanan', label: 'Perjalanan', obj: 'tab-perjalanan' },
  { to: '/quran', label: "Qur'an", obj: 'tab-quran' },
  { to: '/cerita', label: 'Cerita', obj: 'tab-cerita' },
]

const under = (path: string, base: string) => path === base || path.startsWith(`${base}/`)
const isOn = (t: Tab, path: string) => (t.to === '/' ? path === '/' : under(path, t.to)) || (t.also ?? []).some((b) => under(path, b))

/**
 * Bottom tab bar on phones, sidebar from 1024px (pure CSS). Settings opens from the profile icon on Home. One indicator
 * slides to the current tab: a short bar on phones, the highlight behind the item in the sidebar.
 */
export function TabBar() {
  const { pathname } = useLocation()
  const nav = useRef<HTMLElement>(null)

  useLayoutEffect(() => {
    const el = nav.current
    if (!el) return
    const place = () => {
      const a = el.querySelector<HTMLElement>('a[aria-current="page"]')
      el.dataset.ind = a ? 'on' : 'off'
      if (!a) return
      el.style.setProperty('--ind-x', `${a.offsetLeft + a.offsetWidth / 2 - 14}px`)
      el.style.setProperty('--ind-y', `${a.offsetTop}px`)
    }
    place()
    // no slide on the first paint, only between tabs: apply the position (reading layout flushes styles) before the
    // transition is switched on
    void el.querySelector('.tab-ind')?.getBoundingClientRect()
    const t = requestAnimationFrame(() => { el.dataset.ready = '' })
    window.addEventListener('resize', place)
    return () => { cancelAnimationFrame(t); window.removeEventListener('resize', place) }
  }, [pathname])

  return (
    <nav className="tabbar" aria-label="Menu utama" ref={nav}>
      <i className="tab-ind" aria-hidden="true" />
      <div className="side-brand" aria-hidden="true">
        <img src="/favicon.png" width={32} height={32} alt="" /> IqraPath
      </div>
      {TABS.map((t) => (
        <Link key={t.to} to={t.to} aria-current={isOn(t, pathname) ? 'page' : undefined}>
          <Obj id={t.obj} size={28} className="tab-ic" eager />
          {t.label}
        </Link>
      ))}
      <p className="side-note">Terjemahan merujuk Kemenag RI. Bahan renungan, bukan fatwa.</p>
    </nav>
  )
}
